<template>
	<div class="info-status-page">
		<ProfileMain
			v-if="isTablet"
			:phoneAuth="store.state.user.app_auth === 'phone'"
			:hasASP="store.state.user.user_state === 'current_with_ahs'"
			class="profile-main--margin-left"
			:fullName="fullName"
			:phone="store.state.user?.phone.number"
			:dataReady="dataReady"/>
		<InfoStatus/>
		<WebPush
			v-show="computedShowWebPush"
			:computedShowWebPush="computedShowWebPush"
			@closeWebpush="showWebPush = false"
			@webpushAfterResetToken="(val) => webpushAfterResetToken = val"
		/>
	</div>
</template>

<script setup>

import ProfileMain from '@/entities/components/ProfileMain';
import { useStore } from 'vuex';
import { computed, ref, watch } from 'vue';
import InfoStatus from '@/entities/components/InfoStatus/InfoStatus.vue';
import WebPush from '@/features/WebPush/WebPush.vue';
import { getCookie } from '@/shared/lib/helpers/cookies';
import { useStorage } from '@vueuse/core';

const store = useStore();
const isTablet = computed(() => store.state.isTablet.isTablet);
const fullName = computed(() => `${store.state.user.first_name} ${store.state.user.last_name}`);
const dataReady = computed(() => {
	if (store.state.user.app_auth === 'phone') {
		return !!store.state.user?.phone.number;
	}

	return !!(store.state.user?.first_name && store.state.user?.last_name && store.state.user?.phone.number);
});

// const isIOS = computed(() => /CriOS/i.test(navigator.userAgent) && /iphone|ipod|ipad/i.test(navigator.userAgent));
const isIOS = computed(() => /iphone|ipod|ipad/i.test(navigator.userAgent));
const yandexStart = computed(() => document.referrer.includes('yandex.ru'));
const yaBrowser = computed(() => /YaBrowser/i.test(navigator.userAgent));
const showWebPush = ref(true);
const fbToken = useStorage('fbToken', null);
const webpushAfterResetToken = ref(false);
/*
* Показываем плашку если:
* 1) Устройство не iOS
* 2) Мы не нажали кнопку "Да хочу" или "Позже", которые закрывают ее и сохр. данные в localStorage о том, что плашка закрыта вручную
* 3) Если нет активной заявки (значение приходит после получения токена в функции checkSubscription)
* */

console.log('fbToken.value', fbToken.value);
console.log('getCookie(\'webPushHidden\')', getCookie('webPushHidden'));
const computedShowWebPush = computed(() => {
	console.log('------------------INSIDE COMPUTED-------------------');
	console.log(showWebPush.value);
	console.log(fbToken.value);
	console.log('-----------------INSIDE COMPUTED----------------');
	if (!getCookie('webPushHidden') && ((!yaBrowser.value && !yandexStart.value && !isIOS.value && showWebPush.value && !fbToken.value) || webpushAfterResetToken.value)) {
		return true;
	}
	return false;
	// if (getCookie('webPushHidden') && isIOS.value && !showWebPush.value && !fbToken.value) {
	// 	return false;
	// }
	// return true;
});

watch([() => showWebPush.value, () => fbToken.value], (val) => {
	const [show, token] = val;
	console.log('showWebpush INFOSTATUS:', show);
	console.log('token INFOSTATUS ', token);
}, { immediate: true });

</script>

<style lang="scss" scoped>

</style>
